import { UserPriv } from "luxedo-data"

export const LUX_AI_PRIV = "lux_ai" as UserPriv
// Typed annotation (not a cast) so a rename in the UserPriv union fails the build here
export const COURT_PORTAL_PRIV: UserPriv = "court_portal_user"
export const PRO_PRIV: UserPriv = "pro"

/** Per-environment URL of the new court-portal app. Users holding
 * COURT_PORTAL_PRIV get a sidebar link + one-time invite pointing here. */
export const COURT_PORTAL_URL: string | undefined = import.meta.env.VITE_COURT_PORTAL_URL
